import { render, staticRenderFns } from "./Step-5.vue?vue&type=template&id=28c0582d&scoped=true&"
import script from "./Step-5.vue?vue&type=script&lang=js&"
export * from "./Step-5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c0582d",
  null
  
)

export default component.exports